import { render, staticRenderFns } from "./F5nicForm.vue?vue&type=template&id=38e432ae&"
import script from "./F5nicForm.vue?vue&type=script&lang=js&"
export * from "./F5nicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports